// Klientské části her. Novou hru přidej sem (viz docs/ADD_A_GAME.md).
import type { ClientGameModule } from "./types.ts";
import { pexesoClient } from "./pexeso/index.ts";
import { unoClient } from "./uno/index.ts";
import { kolonieClient } from "./kolonie/index.ts";

export const CLIENT_GAMES: Record<string, ClientGameModule> = {
  [pexesoClient.id]: pexesoClient,
  [unoClient.id]: unoClient,
  [kolonieClient.id]: kolonieClient,
};
